// extracted by mini-css-extract-plugin
export var carrierTab = "_5i-0";
export var carrierTabActive = "_5i-1 _5i-0";
export var carrierTabInactive = "_5i-2 _5i-0";
export var carrierTabLabel = "_5i-3";
export var carrierTabLabelActive = "_5i-4 _5i-3";
export var carrierTabLabelInactive = "_5i-5 _5i-3";
export var carrierTabPercentage = "_5i-6";
export var carrierTabPercentageActive = "_5i-7 _5i-6";
export var carrierTabPercentageInactive = "_5i-8 _5i-6";
export var carrierTabWinnable = "_5i-9";
export var carrierTabWinnableActive = "_5i-a _5i-9";
export var carrierTabWinnableInactive = "_5i-b _5i-9";
export var comparisonContainer = "_5i-d";
export var missingRateButton = "_5i-n";
export var missingRateButtonActive = "_5i-o _5i-n";
export var missingRateButtonInactive = "_5i-p _5i-n";
export var missingRateButtonLabel = "_5i-q";
export var missingRateButtonLabelActive = "_5i-r _5i-q";
export var missingRateButtonLabelInactive = "_5i-s _5i-q";
export var sidebar = "_5i-c";
export var strategyButton = "_5i-e";
export var strategyButtonActive = "_5i-f _5i-e";
export var strategyButtonDescription = "_5i-k";
export var strategyButtonDescriptionActive = "_5i-l _5i-k";
export var strategyButtonDescriptionInactive = "_5i-m _5i-k";
export var strategyButtonInactive = "_5i-g _5i-e";
export var strategyButtonLabel = "_5i-h";
export var strategyButtonLabelActive = "_5i-i _5i-h";
export var strategyButtonLabelInactive = "_5i-j _5i-h";
export var unitToggleButton = "_5i-t";
export var unitToggleButtonActive = "_5i-u _5i-t";
export var unitToggleButtonInactive = "_5i-v _5i-t";
export var unitToggleButtonLabel = "_5i-w";
export var unitToggleButtonLabelActive = "_5i-x _5i-w";
export var unitToggleButtonLabelInactive = "_5i-y _5i-w";